<flowaccount-functions-for-business-intro></flowaccount-functions-for-business-intro>

<flowaccount-tax-invoice-banner-shared [contentList]="mockContent"></flowaccount-tax-invoice-banner-shared>

<flowaccount-tax-calendar-swiper></flowaccount-tax-calendar-swiper>

<flowaccount-functions-for-business-feature></flowaccount-functions-for-business-feature>

<flowaccount-content-call-to-action-squidex
  [contentCTA_1]="'CONTENT_CTA_SQUIDEX_BUSINESS.HEADING_1'"
  [contentCTA_2]="'CONTENT_CTA_SQUIDEX_BUSINESS.HEADING_2'"
  [contentTextLink]="'CONTENT_CTA_SQUIDEX_BUSINESS.BUTTON_LINK'"
  [contentScully]="'CONTENT_CTA_FUNCTION_BUSINESS'"
  [previousPath]="signupPreviousPath.BUSINESS"
>
</flowaccount-content-call-to-action-squidex>

<flowaccount-review-setion
  [bgColorTheme]="'blue-light-bg'"
  [customTextList]="reviewSectionTextListBusiness"
></flowaccount-review-setion>

<flowaccount-blog-swiper-squidex
  [lang]="translate.currentLang"
  [contentSquidex]="'business-blog'"
  [contentScully]="'business-blog-key'"
></flowaccount-blog-swiper-squidex>

<flowaccount-starter-kit-shared></flowaccount-starter-kit-shared>

<ng-container *ngIf="translate.currentLang === 'th'">
  <flowaccount-faq-accordion-squidex
    [contentSquidex]="'functions-business-faq'"
    [contentScully]="'functions-business-faq-key'"
  ></flowaccount-faq-accordion-squidex>
</ng-container>
